import styled from 'styled-components';

import { hexWithAlpha } from '@p2l/utils';

import { TextButton } from './buttons';
import { DialogBody } from './dialog';

export const SignOutButton = styled(TextButton)`
  color: var(--p2l-error-color, #e64845);

  &:hover {
    background-color: ${hexWithAlpha('#e64845', 8)};
  }
`;

export const StyledDialogBody = styled(DialogBody)`
  padding: 16px;
`;

export const DevFrameOpenButton = styled(TextButton)`
  margin-left: 300px;
  margin-top: 200px;
`;
